/**
 * useDUNSVisibility will control whether or not
 * show DUNS references around the platform, so that we have a single source of truth
 *
 * @returns boolean
 */

import { dnbDataEnabled, userHasClaims } from "../utils/auth";

export const useDUNSVisibility = () => {
  return userHasClaims([dnbDataEnabled]);
};
